var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCreated(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1838_60399)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.4375 7.5V1.6875C17.4375 1.38913 17.319 1.10298 17.108 0.892005C16.897 0.681026 16.6109 0.5625 16.3125 0.5625H1.6875C1.38913 0.5625 1.10298 0.681026 0.892005 0.892005C0.681026 1.10298 0.5625 1.38913 0.5625 1.6875V11.8125C0.5625 12.1109 0.681026 12.397 0.892005 12.608C1.10298 12.819 1.38913 12.9375 1.6875 12.9375H5.8125",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.81259 6.174C6.79262 6.174 7.58709 5.37953 7.58709 4.3995C7.58709 3.41947 6.79262 2.625 5.81259 2.625C4.83256 2.625 4.03809 3.41947 4.03809 4.3995C4.03809 5.37953 4.83256 6.174 5.81259 6.174Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.83701 9.72213H2.77051C2.77042 9.12968 2.94334 8.55009 3.26804 8.05453C3.59273 7.55897 4.05507 7.16901 4.59828 6.93253C5.1415 6.69605 5.74194 6.62334 6.3259 6.72332C6.90986 6.82331 7.45191 7.09165 7.88551 7.49538",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6875 3.375H14.0625",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6875 5.625H15.1875",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.9375 17.4375C15.4228 17.4375 17.4375 15.4228 17.4375 12.9375C17.4375 10.4522 15.4228 8.4375 12.9375 8.4375C10.4522 8.4375 8.4375 10.4522 8.4375 12.9375C8.4375 15.4228 10.4522 17.4375 12.9375 17.4375Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.943 11.6289L12.7643 14.5344C12.7198 14.5936 12.6641 14.6434 12.6004 14.681C12.5367 14.7187 12.4662 14.7434 12.3929 14.7538C12.3196 14.7642 12.245 14.76 12.1734 14.7415C12.1017 14.7231 12.0344 14.6907 11.9753 14.6462C11.9543 14.6303 11.9345 14.613 11.916 14.5944L10.791 13.4694",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1838_60399"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreated);
export default __webpack_public_path__ + "static/media/Created.f7a2c436aad52ffd7fd88d328075c6d6.svg";
export { ForwardRef as ReactComponent };